
import { IMemberViewOverviewState } from './state';
import { createReducer, on, Action } from '@ngrx/store';
import {
  onNgrxForms, onNgrxFormsAction, SetValueAction
} from 'ngrx-forms';
import { ResponseAction } from './actions';
import { MemberModel } from '../../../../model/member.model';


export const loginState: IMemberViewOverviewState = {
  model: new MemberModel()
};

const reducer = createReducer(loginState,
  onNgrxForms(),
  onNgrxFormsAction(SetValueAction, (state, action) => {
    return state;
  }),
  on(ResponseAction, (state, { payload }) => {
    return {
      ...state,
      model: payload
    };
  })
);

export function memberViewOverviewReducer(state: any | undefined, action: Action) {
  return reducer(state, action);
}
